import React, { useEffect, useState } from "react";
import Header from "../../../components/Header/Header";
import Box from "@mui/material/Box";
import { TextField, OutlinedInput } from "@mui/material";
import ProjectHeader from "../../../components/Header/ProjectHeader";
import { FormControl, Grid, Select, MenuItem } from "@mui/material";
import Footer from "../../../components/Footer";
import "./batchProcess.scss";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserList,
  isSignatureUploaded,
  clearIsSignatureUploadedStatus,
  validateUserPermission,
  clearApiStatus,
  validateUserClear,
  getInvestigatorUserList,
} from "../../../redux/pre_processor/actions";
import Authentication from "../../../components/Modal/PopupModal/PopupModal";
import ModalSign from "../../../components/Modal/Signature/ModalSign";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import BatchStepper from "../../../components/Stepper/BatchStepperCpvAuto";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import ProgressBar from "../../../components/ProgressBar";
import Label from "../../../components/Label/Label";
import { notification } from "../../../constants/notificationMessages";
import constants from "../../../constants/constantValues";
import { preProRoutes } from "../../../routes/routeConstants";

const BatchProcessPreProcessor = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [timeLineEndDate, setTimeLineEndDate] = useState(null);
  const [userName, setUserName] = useState("");
  const [openAuth, setOpenAuth] = useState(false);
  const [openSignPad, setOpenSignPad] = useState(false);
  const remark = notification.remarkPre;
  const getProUser = useSelector((state) => state?.prePro?.userList);
  const getReviewerUser = useSelector(
    (state) => state?.prePro?.investigatorUserList,
  );
  const [message, setMessage] = useState("");
  const [err, setErr] = useState(false);
  const [success, setSuccess] = useState(false);
  const signUploaded = useSelector(
    (state) => state?.prePro?.isSignatureUploaded,
  );
  const apiStatus = useSelector((state) => state?.prePro?.apiStatus);
  const { SUBJECT, TIMELINE, SELECT, SUBMIT_PROCESSING, SUBMIT_MAPPING_APPRVAL } =
    constants;

  const mappingOption = localStorage.getItem("mappingOption");
  useEffect(() => {
    if (apiStatus && apiStatus !== undefined) {
      if (apiStatus?.loading === false) {
        if (
          apiStatus?.message !== undefined ||
          apiStatus?.message !== null ||
          apiStatus?.apiSuccess === true
        ) {
          if (apiStatus?.next === true) {
            setSuccess(true);
            setMessage(apiStatus?.message);
            setTimeout(() => {
              navigate(`/${preProRoutes.preProDashboard}`);
            }, 2000);
            dispatch(clearApiStatus());
          }
        } else if (apiStatus?.apiError === true) {
          setErr(true);
          setMessage(apiStatus?.message);
          dispatch(clearApiStatus());
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiStatus]);

  const subject =
    mappingOption === "batch"
      ? notification.subjectPre
      : notification.subjectValiApproval;

  useEffect(() => {
    dispatch(
      mappingOption === "batch" ? getUserList() : getInvestigatorUserList(),
    );
    dispatch(clearApiStatus());
    dispatch(clearIsSignatureUploadedStatus());
    dispatch(isSignatureUploaded());
    dispatch(validateUserClear());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClick = (event, action) => {
    //Electronic signature
    dispatch(isSignatureUploaded());
    if (action === "continue") {
      if (signUploaded?.isSignatureUploaded !== undefined) {
        if (signUploaded?.isSignatureUploaded === false) {
          setOpenSignPad(true);
        }
        if (signUploaded?.isSignatureUploaded === true) {
          setOpenAuth(true);
        }
      }
    }
  };

  const handleUserPermission = () => {
    //submitting batch for processing
    const projectId = localStorage.projectId;
    const batchId = localStorage.batchId;
    const endDate = format(timeLineEndDate, "yyyy-MM-dd");
    dispatch(
      validateUserPermission({
        userName,
        projectId,
        batchId,
        endDate,
        subject,
        remark,
        mappingOption,
      }),
    );
  };
  const handleEsignDialogBoxClose = () => {
    setOpenSignPad(false);

    setTimeout(() => {
      dispatch(isSignatureUploaded());
    }, 1500);
  };

  return (
    <>
      <React.Fragment>
        <Header page="new-project" />
        <BatchStepper currentStep={2} />
        <ProjectHeader
          position="center"
          headerColor="#F5F5F5"
          text={
            mappingOption === "batch"
              ? localStorage.projectName + "-" + localStorage.batchName
              : localStorage.projectName
          }
        />
        <Box className="batchProcessing">
          <Grid container className="h-center">
            <Grid item md={4}>
              <div className="input-wrap-title">
                <Label
                  fontSize="16px"
                  fontWeight="500"
                  text={
                    mappingOption === "batch"
                      ? SUBMIT_PROCESSING
                      : SUBMIT_MAPPING_APPRVAL
                  }
                ></Label>
              </div>
              <form action="" className="batch-processing-form">
                <FormControl fullWidth>
                  <div className="input-wrap">
                    <label>{SUBJECT}</label>
                    <TextField
                      className="field-style"
                      size="small"
                      fullWidth
                      readOnly
                      placeholder={SUBJECT}
                      value={subject}
                      disabled
                    />
                  </div>
                  <div className="input-wrap">
                    <label>{SELECT}</label>
                    <Select
                      className="field-style"
                      fullWidth
                      value={userName}
                      name={SELECT}
                      input={
                        <OutlinedInput
                          onChange={(event) => setUserName(event.target.value)}
                        />
                      }
                    >
                      {mappingOption === "batch"
                        ? getProUser &&
                          getProUser.all_processor &&
                          getProUser.all_processor.length > 0 &&
                          getProUser.all_processor.map((option, index) => (
                            <MenuItem key={index} value={option}>
                              {option}
                            </MenuItem>
                          ))
                        : getReviewerUser &&
                          getReviewerUser.length > 0 &&
                          getReviewerUser.map((option, index) => (
                            <MenuItem value={option.username}>
                              {option.username}
                            </MenuItem>
                          ))}
                    </Select>
                  </div>
                  <div className="input-wrap">
                    <label>{TIMELINE}</label>
                    <DatePicker
                      className="Date-picker"
                      variant="outlined"
                      onChange={(date) => setTimeLineEndDate(date)}
                      selected={timeLineEndDate}
                      minDate={new Date()}
                      showDisabledMonthNavigation
                    />
                  </div>
                </FormControl>
              </form>
            </Grid>
          </Grid>
          {openAuth && (
            <Authentication
              openAuth={openAuth}
              handleClose={() => setOpenAuth(false)}
              handleUserPermission={handleUserPermission}
            />
          )}

          {openSignPad && (
            <ModalSign
              openSignPad={openSignPad}
              handleEsignDialogBoxClose={() => handleEsignDialogBoxClose(false)}
            ></ModalSign>
          )}
        </Box>
        <Footer
          isNextDisable={
            subject !== "" && userName !== "" && timeLineEndDate !== null
              ? false
              : true
          }
          isSaveDisable={true}
          isPrevious={false}
          onHandleClick={(event, action) => onClick(event, action)}
        />

        {success && (
          <CustomizedSnackbars
            severity="success"
            state={success}
            text={message}
            handleClose={() => setSuccess(false)}
          />
        )}

        {err && (
          <CustomizedSnackbars
            severity="error"
            state={err}
            text={message}
            handleClose={() => setErr(false)}
          />
        )}

        {apiStatus.loader && <ProgressBar />}
      </React.Fragment>
    </>
  );
};
export default BatchProcessPreProcessor;
